import React from 'react';
import { connect } from 'react-redux';
import { TrashIcon } from '@components/drive/driveIcons';
import {
  OrganizationButtons,
  Export,
  Delete,
  AddButton,
} from '../../../../../../UI/Editor/EditSpace/EditorPane/RenderContent/organizationDetails';
import {
  SquareCheckMarkColored,
  Square,
  Add,
} from '../../../../../../editJournal/toolset/assets/icons';

const Buttons = (props) => {
  const {
    mark,
    selectAll,
    rolesCount,
    node,
    handleExport: exportHandler,
    handleDelete: deleteHandler,
    handleInsertOrganization: addHandler,
    stopDrag,
    editor,
    currentOrdinal,
    currentOrganization,
    isFocused,
    universityPlan,
  } = props;

  const nodeType = node.type;
  const nodeKey = node?.key;
  const path = editor?.value?.document?.getPath(nodeKey)?.toJS();
  const pathSuffix = path ? `-${path.join('-')}` : '';

  const handleExport = (e) => exportHandler(e);

  const handleDelete = (e) => deleteHandler(e);

  const handleAdd = (e) => addHandler(e);

  return (
    <OrganizationButtons
      onMouseDown={(e) => e.preventDefault() && stopDrag()}
      isFocused={isFocused}
      contentEditable={false}
    >
      <AddButton
        onMouseDown={(e) => e.preventDefault() && stopDrag()}
        onClick={(e) =>
          handleAdd({
            event: e,
            editor,
            currentOrdinal,
            currentOrganization,
            universityPlan,
          })
        }
        contentEditable={false}
        data-testid={`${nodeType}_add${pathSuffix}`}
        nodeType={nodeType}
      >
        <Add width="16px" height="16px" />
      </AddButton>
      <Delete
        onMouseDown={(e) => e.preventDefault() && stopDrag()}
        onClick={(e) => handleDelete(e)}
        contentEditable={false}
        data-testid={`${nodeType}_delete${pathSuffix}`}
        rolesCount={rolesCount}
        active={rolesCount > 1}
      >
        <TrashIcon width="16px" height="16px" disabled={rolesCount <= 1} />
      </Delete>
      <Export
        onMouseDown={(e) => e.preventDefault() && stopDrag()}
        onClick={(e) => handleExport(e)}
        contentEditable={false}
        data-testid={`${nodeType}_export${pathSuffix}`}
      >
        {
          {
            true: (
              <SquareCheckMarkColored
                width="16px"
                height="16px"
                dataTestId={`${nodeType}_check${pathSuffix}`}
                selectAll={selectAll}
                parentCheckMark
              />
            ),
            false: (
              <Square
                width="16px"
                height="16px"
                dataTestId={`${nodeType}_uncheck${pathSuffix}`}
              />
            ),
          }[mark]
        }
      </Export>
    </OrganizationButtons>
  );
};

const mapStateToProps = (state) => ({
  activePlan: state.userInfoReducer.activePlan,
  subscriptionStatus: state.userInfoReducer.subscriptionStatus,
  formatType: state.editResumeFormReducer.formatType,
  universityPlan: state.userInfoReducer.universityPlan,
});

export default connect(mapStateToProps)(Buttons);
